export default {
    getEducationalGroups: { method: 'get', url: 'educational_groups' },
    postEducationalGroups: { method: 'post', url: 'educational_groups' },
    putEducationalGroups: { method: 'put', url: 'educational_groups/{id}' },
    deleteEducationalGroups: { method: 'delete', url: 'educational_groups/{id}' },
}
